import { render, staticRenderFns } from "./MessageDetailPage.vue?vue&type=template&id=6ea963ac&scoped=true"
import script from "./MessageDetailPage.vue?vue&type=script&lang=js"
export * from "./MessageDetailPage.vue?vue&type=script&lang=js"
import style0 from "./MessageDetailPage.vue?vue&type=style&index=0&id=6ea963ac&prod&style=true&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea963ac",
  null
  
)

export default component.exports